/**
 * @generated SignedSource<<24be1fa9f3f01baca86c8184e0e012cc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrganisationRoleType = "ADMIN" | "DEVELOPER" | "WORKSPACE_USER";
export type WorkspaceRoleType = "ADMIN" | "READ_ONLY";
export type OrgUserEditScreenQuery$variables = {
  userId: string;
};
export type OrgUserEditScreenQuery$data = {
  readonly organisation: {
    readonly user: {
      readonly orgRole: OrganisationRoleType;
      readonly user: {
        readonly email: string;
        readonly id: string;
        readonly name: string;
      };
      readonly workspaceRoles: ReadonlyArray<{
        readonly roleType: WorkspaceRoleType;
        readonly workspace: {
          readonly id: string;
          readonly name: string;
          readonly subWorkspaceCount: number;
        };
      }>;
    };
    readonly workspaces: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"OrgUserEditAccessSelect_workspaces" | "WorkspaceRolesSelector_workspaces">;
    }>;
  };
};
export type OrgUserEditScreenQuery = {
  response: OrgUserEditScreenQuery$data;
  variables: OrgUserEditScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subWorkspaceCount",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "userId"
    }
  ],
  "concreteType": "OrgUser",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orgRole",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserWorkspaceRole",
      "kind": "LinkedField",
      "name": "workspaceRoles",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Workspace",
          "kind": "LinkedField",
          "name": "workspace",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "roleType",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgUserEditScreenQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": null,
          "concreteType": "Organisation",
          "kind": "LinkedField",
          "name": "organisation",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Workspace",
              "kind": "LinkedField",
              "name": "workspaces",
              "plural": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "OrgUserEditAccessSelect_workspaces"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "WorkspaceRolesSelector_workspaces"
                }
              ],
              "storageKey": null
            },
            (v4/*: any*/)
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OrgUserEditScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Organisation",
        "kind": "LinkedField",
        "name": "organisation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Workspace",
            "kind": "LinkedField",
            "name": "workspaces",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "parentId",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "096b691a706737ee293db922e707091f",
    "id": null,
    "metadata": {},
    "name": "OrgUserEditScreenQuery",
    "operationKind": "query",
    "text": "query OrgUserEditScreenQuery(\n  $userId: String!\n) {\n  organisation {\n    workspaces {\n      ...OrgUserEditAccessSelect_workspaces\n      ...WorkspaceRolesSelector_workspaces\n      id\n    }\n    user(id: $userId) {\n      user {\n        id\n        name\n        email\n      }\n      orgRole\n      workspaceRoles {\n        workspace {\n          id\n          name\n          subWorkspaceCount\n        }\n        roleType\n      }\n    }\n    id\n  }\n}\n\nfragment OrgUserEditAccessSelect_workspaces on Workspace {\n  id\n  name\n  subWorkspaceCount\n  ...WorkspaceSelectorContent_workspaces\n}\n\nfragment WorkspaceRolesSelector_workspaces on Workspace {\n  ...OrgUserEditAccessSelect_workspaces\n}\n\nfragment WorkspaceSelectorContent_workspaces on Workspace {\n  id\n  name\n  parentId\n}\n"
  }
};
})();

(node as any).hash = "79548860e4ed11a34069ec8670ece843";

export default node;
